module.exports = __webpack_public_path__ + "img/SKMJ_enter2.b8733081.png";